import React, { useMemo } from "react";
import { Helmet } from "react-helmet";
import { HomePageBanner } from "../../blocks/home-page-banner";
import { Header } from "../../components/Header";
import { useTranslation } from "react-i18next";
import { ApiComponent } from "../../blocks/open-api";
import { ManualComponent } from "../../blocks/open-manual";
import { Playground } from "../../blocks/open-playground";
import { Application } from "../../blocks/open-application";
import { JoinAuthing } from "../../blocks/open-join-authing";
import { Footer } from "../../components/FooterV2";
import { highlight } from "../../utils/highlight";
import { StyledMarkdownBlock } from "../../components/CodeView";
import { host } from "../../config/openapi";

export const OpenPage = () => {
  const { t } = useTranslation();
  const banners = useMemo(() => {
    return [
      {
        title: t("open.banner.item1.title"),
        title2: t("open.banner.item1.title2"),
        subtitle: t("open.banner.item1.subtitle"),
        subtitleSmall: t("open.banner.item1.subtitleSmall"),
        bg: "open-banner.png",
        btnUrl: "https://docs.authing.cn/",
        btnName: t("open.banner.item1.btnName"),
        link: host,
        linkName: t("open.banner.item1.linkName"),
      },
    ];
  }, [t]);

  return (
    <div className="open-page">
      <Helmet>
        <title>
          Authing身份云-SSO单点登录系统-MFA多因素认证-统一身份认证平台-中国版OKTA-零信任-IDaaS-以开发者为中心
        </title>
      </Helmet>
      <Header mode="dark" />
      <HomePageBanner banners={banners} />
      <ApiComponent />
      <ManualComponent />
      <Playground />
      <Application />
      <JoinAuthing />
      <Footer />
    </div>
  );
};
